if (!customElements.get('announcement-bar')) {
  customElements.define(
    'announcement-bar',
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();

        /** @type {HTMLElement | null} */
        this.carousel = this.querySelector('.swiper');

        this.controller = null;
      }

      connectedCallback() {
        const swiper = window.swiper.Swiper;

        /** @type {HTMLElement | null} */
        const root = document.querySelector(':root');

        if (this.carousel) {
          this.controller = new swiper(this.carousel, {
            modules: [window.swiper.Autoplay],
            direction: 'vertical',
            loop: this.carousel.querySelectorAll('.swiper-slide').length > 1 ? true : false,
            slidesPerView: 'auto',
            autoHeight: true,
            allowTouchMove: false,
            init: this.carousel.querySelectorAll('.swiper-slide').length > 1 ? true : false,
            autoplay: {
              delay: 5000,
            },
            on: {
              init: () => {
                if (root) {
                  root.style.setProperty('--announcement-bar-height', `${this.scrollHeight}px`);
                }
              },
              resize: () => {
                if (root) {
                  root.style.setProperty('--announcement-bar-height', `${this.scrollHeight}px`);
                }
              },
              activeIndexChange: (e) => {
                if (this.carousel) {
                  const idx = e.realIndex;
                  const slide = this.carousel.querySelector(`[data-swiper-slide-index="${idx}"]`);

                  if (slide && slide instanceof HTMLElement && this.parentElement) {
                    const scheme = slide.dataset.slideScheme;

                    this.parentElement.dataset.scheme = scheme || 'scheme-1';
                  }
                }
              },
            },
          });

          this.carousel.addEventListener('focusin', (e) => {
            if (this.controller && e.target && e.target instanceof HTMLElement) {
              this.controller.autoplay.stop();

              const slide = e.target.closest('.swiper-slide');

              if (slide && slide instanceof HTMLElement && Number(slide.dataset.swiperSlideIndex)) {
                this.controller.slideTo(Number(slide.dataset.swiperSlideIndex));
                this.controller.autoplay.pause();
              }
            }
          });
        }
      }
    },
  );
}
